import { render, staticRenderFns } from "./headerMore.vue?vue&type=template&id=3f295894&scoped=true"
import script from "./headerMore.vue?vue&type=script&lang=js"
export * from "./headerMore.vue?vue&type=script&lang=js"
import style0 from "./headerMore.vue?vue&type=style&index=0&id=3f295894&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f295894",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f295894')) {
      api.createRecord('3f295894', component.options)
    } else {
      api.reload('3f295894', component.options)
    }
    module.hot.accept("./headerMore.vue?vue&type=template&id=3f295894&scoped=true", function () {
      api.rerender('3f295894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/headerMore.vue"
export default component.exports